import {FC} from 'react';
import {Box, Typography} from '@mui/material';
import Input from '@/shared/components/Inputs/Input';
import {BODY2, H5} from '@/utils/constants';
import {ReactComponent as DollarIcon} from '@icons/dollar-circle.svg';
import {makeDonationModalStyle} from './MakeDonationModal.styles';
import {isValidPositiveAmount} from '@/utils/helpers';

export const donationOptions = ['25', '50', '100', '300', '500', '1000'];

interface MakeDonationModalProps {
	selectedOption: string;
	setSelectedOption: (value: string) => void;
	error: string;
}

const MakeDonationModal: FC<MakeDonationModalProps> = ({selectedOption, setSelectedOption, error}) => {
	const onHandleChange = (value: string) => {
		if (value === '') {
			setSelectedOption('');

			return;
		}

		const isValid = isValidPositiveAmount(value);
		if (isValid) {
			setSelectedOption(value);
		}
	};

	return (
		<Box sx={{width: '100%'}}>
			<Typography variant={H5} sx={makeDonationModalStyle.title}>
				Donation
			</Typography>

			<Box sx={makeDonationModalStyle.optionsList}>
				{donationOptions.map((option) => (
					<Typography
						sx={{
							...makeDonationModalStyle.option,
							...(selectedOption === option && makeDonationModalStyle.selectedOption),
						}}
						variant={BODY2}
						key={option}
						onClick={() => setSelectedOption(option)}
					>
						${option}
					</Typography>
				))}
			</Box>

			<Box sx={makeDonationModalStyle.search}>
				<DollarIcon />
				<Input
					placeholder="0"
					value={selectedOption}
					onChange={(value: string) => onHandleChange(value)}
					label="Enter your custom amount"
					disableErrorMessage={false}
					errorMessage={error}
					type="text"
				/>
			</Box>
		</Box>
	);
};

export default MakeDonationModal;
